import AbstractFileInput from './AbstractFileInput';

export default class Video extends AbstractFileInput {


    getBaseConfig() {

        var data =  super.getBaseConfig() ;

        if(   this.dataset.maxsize !==undefined){
            data.maxFileSize = parseInt(this.dataset.maxsize);
        }

        return data;
    }

    getAllowedFileTypes() {
        return ['video'];
    }

    getFileActionSettings() {
        return {
            showDrag: false,
        };
    }
}
